/**
 * Força aproximada de cada seleção da Copa 2026 (escala 1-100).
 * Usada para gerar palpites automáticos plausíveis.
 *
 * Base: ranking FIFA mais recente (estimativa 2026), tradição em Copas
 * anteriores, performance continental e elenco atual.
 *
 * Importante: estreantes (CPV, CUW, JOR, UZB) têm força levemente
 * REBAIXADA em relação ao ranking puro, pois historicamente seleções
 * em sua primeira Copa rendem abaixo da expectativa nominal — o que
 * deixa o auto-preenchimento mais coerente com o que costuma acontecer
 * num Mundial real (favorito vence, raras zebras, e estreantes em geral
 * caem na fase de grupos).
 *
 * Não pretende ser exato — é só para o auto-preenchimento gerar
 * resultados plausíveis e dentro do esperado.
 */
export const FORCA_TIMES_COPA_2026: Record<string, number> = {
  // Elite (88-95) - candidatas reais ao título
  FRA: 95,
  ARG: 94,
  BRA: 92,
  ESP: 92,
  ENG: 91,
  POR: 89,
  GER: 88,
  NED: 87,

  // Top (80-86) - briga por quartas/semi
  BEL: 84,
  CRO: 83, // Vice 2018, semi 2022 - mas envelhecida
  URU: 83,
  COL: 82, // Vice Copa América 2024
  MAR: 84, // 4º Copa 2022 - merece um pouco mais
  NOR: 78, // Haaland + Ødegaard, mas 1ª Copa em 28 anos → estreante de elite

  // Sólidos (72-78) - briga por oitavas
  JPN: 77, // Bom histórico recente, eliminou Alemanha em 2022
  SEN: 75, // Camp. Africana 2022, mas elenco oscilante
  ECU: 74,
  MEX: 74,
  SUI: 74, // Tradição em Copas
  USA: 73, // Anfitrião + jovens promissores
  TUR: 73, // Boa Euro 2024
  AUT: 73,
  KOR: 72, // Son Heung-min, mas time fraco
  CIV: 72, // Camp. Africana 2024
  IRN: 70,
  CAN: 70, // Anfitrião, evolução nos últimos anos
  AUS: 69,

  // Médios (62-69) - geralmente caem na fase de grupos
  EGY: 67, // Salah + nada a mais
  SWE: 67, // Histórica, mas em queda
  ALG: 66,
  GHA: 65, // Tradição, mas ruim nas últimas Copas
  CZE: 65,
  PAR: 64,
  SCO: 64, // Sempre cai cedo
  TUN: 64,
  COD: 64, // Congo - 2º na CAN 2024 (semi/4º)
  BIH: 62, // Bósnia - tradicionalmente fraca em Copas
  RSA: 62, // África do Sul - 3º na CAN 2024
  KSA: 62, // Arábia Saudita
  QAT: 60, // Anfitriã 2022 mas péssima campanha lá

  // Fracos / estreantes (50-58) - candidatas a zerar a pontuação
  UZB: 58, // 1ª Copa - força de 60-65 mas estreante derruba
  IRQ: 56,
  JOR: 54, // 1ª Copa - vice CAN da Ásia 2023, mas inexperiente
  PAN: 54,
  CPV: 52, // 1ª Copa - Cabo Verde, ranking FIFA bom mas estreante
  NZL: 52, // Já jogou Copa mas sempre eliminada na 1ª fase
  HAI: 48, // Histórico fraquíssimo
  CUW: 46, // 1ª Copa - Curaçao, menor país a se classificar
};

export function forcaTime(id: string): number {
  return FORCA_TIMES_COPA_2026[id] ?? 60;
}
